import Complaint from "./page/complaint";
import FormComplaint from "./page/formComplaint"
import tbnComplaint from "./page/tbnComplaint";
import tbnFormComplaint from "./page/tbnFormComplaint"
import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

 function App() {
  return (
      <Router>
        {/* <Route exact path="/" component={Complaint} />
        <Route exact path="/form" component={FormComplaint} /> */}
        <Route exact path="/" component={tbnComplaint} />
        <Route exact path="/form" component={tbnFormComplaint} />
      </Router>
  )
}
export default App

